import { useCallback } from 'react';
import { get, set } from 'react-hook-form';
import useValidateDeviceName from './useValidateDeviceName';

function useDeviceNameFormResolver({ name }) {
  const validate = useValidateDeviceName({ name });

  return useCallback(
    async (values, context, options) => {
      const errors = validate(values);
      const names = Object.keys(errors);

      if (names.length === 0) {
        return { values, errors: {} };
      }

      return {
        values: {},
        errors: names.reduce((acc, name) => {
          const field = get(options.fields, name);

          set(acc, name, {
            type: 'validation',
            message: errors[name],
            ref: field?.ref
          });

          return acc;
        }, {})
      };
    },
    [validate]
  );
}

export default useDeviceNameFormResolver;
